/* unplugin-vue-components disabled */import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_i_menu_side_title = _resolveComponent("i-menu-side-title");
  var _component_Badge = _resolveComponent("Badge");
  var _component_MenuItem = _resolveComponent("MenuItem", true);
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_MenuItem, _mergeProps(_ctx.$attrs, {
    to: $props.menu.path,
    replace: $props.menu.replace,
    target: $props.menu.target,
    name: $props.menu.path,
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.handleClick($props.menu.path);
    })
  }), {
    default: _withCtx(function () {
      return [_createVNode(_component_i_menu_side_title, {
        menu: $props.menu,
        "hide-title": $props.hideTitle
      }, null, 8 /* PROPS */, ["menu", "hide-title"]), _ctx.badgeData ? (_openBlock(), _createBlock(_component_Badge, _mergeProps({
        key: 0,
        class: "i-layout-menu-side-badge"
      }, _ctx.badgeData), null, 16 /* FULL_PROPS */)) : _createCommentVNode("v-if", true)];
    }),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["to", "replace", "target", "name"])]);
}